export default "__VITE_ASSET__Dj4Pxdue__"